const ar = {
	home: "الرئيسية",
	services: "الخدمات",
	pricing: "الخطط والأسعار",
	resources: "الموارد",
	contactUs: "اتصل بنا",
	callSales: "اتصل بالمبيعات",
	login: "تسجيل دخول",
	getStarted: "ابدأ الآن!",
	blogs: "المدونة",
	aboutUs: "من نحن",
	partners: "الشركاء",
	tutorials: "الدروس التعليمية",
	faqs: "الأسئلة الشائعة",
	ourTeam: "فريقنا",
	ourVideos: "فيديوهاتنا",
	ourGallery: "معرضنا",
	signUpForEmailUpdates: "اشترك للحصول على تحديثات البريد الإلكتروني",
	subscribeToOurNewsletterTheAccounter:
		"اشترك في النشرة الإخبارية الخاصة بنا The Accounter",
	enterYourEmail: "أدخل بريدك الإلكتروني",
	submit: "إرسال",
	completeBookkeeping: "مسك دفاتر حسابات كاملة",
	trackExpenses: "تتبع النفقات",
	customInvoicing: "الفواتير المخصصة",
	vatServices: "خدمات ضريبة القيمة المضافة",
	insightsAndReports: "الرؤى والتقارير",
	blog: "المدونة",
	careers: "الوظائف",
	other: "المزيد",
	privacyPolicy: "سياسة الخصوصية",
	termsOfUse: "شروط الاستخدام",
	copyright: "جميع الحقوق محفوظة © 2026 ذا اكونتر.",
	trustedByUaeBusinesses: "موثوق به من قبل أكثر من 1,000 شركة إماراتية",
	stopWorryingAboutAccountingWeHandleEverything:
		"توقف عن القلق بشأن المحاسبة. نحن نتولى كل شيء.",
	heroDescription:
		"قم برفع فواتيرك. برنامجنا سهل الاستخدام + خبراء المحاسبة المعتمدون يتولون الباقي: مسك الدفاتر، إعداد ضريبة القيمة المضافة وضريبة الشركات، التقارير المالية، وجميع الإيداعات لدى الهيئة الاتحادية للضرائب نيابة عنك. لا مواعيد نهائية فائتة. لا غرامات — فقط المزيد من الوقت لتنمية عملك.",
	bookFreeConsultation: "احجز استشارة مجانية",
	calculateMySavings: "احسب قيمة التوفير",
	startingAt: "ابتداءً من 250 درهم شهرياً",
	zeroAccountingKnowledgeNeeded: "لا حاجة لأي معرفة محاسبية",
	wePayAnyFinesIfWeMakeAnError:
		"التزام كامل 100%: ندفع نحن أي غرامات إذا أخطأنا",
	officialPartnersOfUaeLeadingOrganizations:
		"الشركاء الرسميون لأبرز المؤسسات في الإمارات",
	whyChooseUs: "ما الذي يميزنا؟",
	whySmartUaeBusinessesChooseTheAccounter:
		"لماذا تختار الشركات الذكية في الإمارات ذا أكاونتر",
	moreThanJustAccountingYourCompleteComplianceAndFinancialPartner:
		"أكثر من مجرد محاسبة - شريكك الكامل في الامتثال والشؤون المالية",
	seeYourExactSavings: "اكتشف قيمة التوفير الفعلية",
	howItWorks: "كيف تعمل الخدمة؟",
	howItWorksDesc: "ارفع فواتيرك. نحن نتولى الباقي. الأمر بهذه البساطة.",
	getStartedToday: "ابدأ الآن",
	testimonials: "آراء العملاء",
	monthly: "شهري",
	quarterly: "ربع سنوي",
	choosePlan: "اختر هذه الخطة",
	frequentlyAskedQuestions: "الأسئلة الشائعة",
	everythingYouNeedToKnowAboutTheAccounter: "كل ما تحتاج معرفته عن ذا أكونتر",
	getStartedWithTheAccounterToday: "ابدأ مع ذا أكونتر اليوم!",
	leaveMessage: "اترك لنا رسالة",
	name: "الإسم",
	yourName: "اسمك",
	email: "عنوان البريد الالكتروني",
	yourEmail: "بريدك الإلكتروني",
	phoneNumber: "رقم الهاتف",
	yourPhoneNumber: "رقم هاتفك",
	companyName: "اسم الشركة",
	message: "رسالتك",
	enterMessage: "أدخل رسالة",
	bookFreeCall: "احجز استشارة مجانية",
	navHowItWorks: "الخطوات",
	company: "الشركة",
	learningHub: "مركز التعلم",
	savingCalculator: "حاسبة التوفير",
	ourServices: "خدماتنا",
	servicesHeroTitle: "إدارة كل حساباتك... من الألف للياء!",
	servicesHeroSubTitle:
		"بنفس الاشتراك تحصل على جميع خدمات الضرائب، ومسك الدفاتر المحاسبية بالكامل، وعبر فريق من الخبراء المعتمدين. ارفع صور الفواتير… ودعنا ندير الباقي.",
	additionalServices: "خدمات إضافية",
	additionalServicesHeadline: "أكثر مما تتوقع… وضمن اشتراكك.",
	additionalServicesSubText:
		"معظم هذه الخدمات مشمولة في اشتراكك الشهري بدون رسوم إضافية، وبدون مفاجآت.",
	fromPrice: "ابتداءً من {{price}} درهم/شهريًا",
	noLongTermContract: "بدون عقود طويلة",
	cancelAnytime: " إلغاء في أي وقت",
	ourPartners: "شركاؤنا",
	partnersHeroHeadline: "شركاء رسميون مع أبرز المؤسسات في الإمارات",
	partnersHeroSubText:
		"نتعاون مع أهم هيئات الأعمال في الإمارات ونقدّم خدمات The Accounter للمؤسسات التابعة لها بأسعار خاصة.",
	whoWeWorkWith: "مع من نعمل؟",
	partnerRegisteration: "التسجيل عبر الشركاء",
	sendRegistrationRequest: "أرسل طلب التسجيل!",
	yourCompanyNameAsPerTradeLicense: "اسم شركتك كما هو مسجل في رخصة التجارة",
	partner: "شريك",
	selectAPartner: "اختر شريكًا",
	fileNumber: "رقم الملف",
	with: "مع",
	send: "أرسل",
	how_it_works: "كيف يعمل النظام",
	uploadYourInvoices: "ارفع مستنداتك!",
	weHandleEverythingElse: "واترك لنا باقي المهمة.",
	howItWorksSubText:
		"لا تحتاج لإجراء أي مقابلات، ولا تحتاج لخبرة في المحاسبة. فقط ارفع صور مستنداتك ودع فريق خبرائنا يتولّى باقي المهمة: الضرائب. مسك الدفاتر. تقارير ومتطلبات الهيئة.",
	theProcess: "الخطوات",
	theProcessHeadline: "ثلاث خطوات بدون تعقيدات",
	theProcessSubText:
		"ركّز على أعمالك ودع فريقنا يتولّى كل شيء من أوّل رفع الفواتير حتى التقديم للهيئة!",
	complianceGuaranteed: "ضمان الامتثال الكامل",
	everythingYouNeedToKnow: "كل ما تحتاج معرفته.",
	academy: "أكاديمية",
	notPartnerMember: "لست متعاونًا مع أحد الشركاء؟",
	notPartnerMemberSubText:
		"يمكنك البدء مباشرة. احجز استشارة مجانية وفريقنا سيوضح لك جميع الخدمات ويجهّز لك كل شئ من البداية.",
	askQuestion: "اطرح سؤالاً...",
	aboutTheAccounter: "نبذة عن The Accounter",
	pageCannotBeFound: "الصفحة غير موجودة",
	letsGetBackToBusiness: "لنعد إلى العمل",
	goToHome: "انتقل إلى الصفحة الرئيسية",
	contactAnExpert: "تواصل مع خبير",
	cancel: "إلغاء",
	allPlansIncludeTheseFeatures: "جميع الباقات تشمل المزايا التالية:",
	savingsCalculator: "حاسبة التوفير",
	calculateYourSavings: "احسب التوفير الآن",
	AED: "درهم",
	month: "شهريًا",
	starter: "الأساسية",
	growth: "المتقدمة",
	scale: "الاحترافية",
	plan: "الباقة",
	year: "سنويًا",
	yourCurrentAnnualCost: "تكلفتك السنوية الحالية",
	withTheAccounter: "مع The Accounter",
	VATPreparationFiling: "إعداد وتقديم إقرارات ضريبة القيمة المضافة",
	corporateTaxPreparationFiling: "إعداد وتقديم إقرارات ضريبة الشركات",
	monthlyFinancialReports: "تقارير مالية شهرية",
	layerExpertValidation: "نظام مراجعة وتدقيق من 6 مراحل",
	worth: "بقيمة",
	plusYouGetFree: "وتحصل أيضًا مجانًا على خدمات",
	totalFreeValue: "إجمالي القيمة الإضافية المجانية",
	getStartedFrom: "اشترك الآن ابتداءً من {{price}} درهم شهريًا",
	overBusinessesUseTheAccounter:
		"أكثر من <span>{{count}}</span> شركة تستخدم برنامج المحاسبة",
	corporateTax: "ضريبة الشركات",
};

export default ar;
